/* ADYASTORE: one GA4 event per telephone-link activation. */
(() => {
  'use strict';
  if (window.__adyaPhoneClickInstalled) return;
  window.__adyaPhoneClickInstalled = true;

  document.addEventListener('click', (event) => {
    // Buddha Mega Menu replays a synthetic click after touchend.
    // Count only the original browser activation; do not debounce distinct taps.
    if (!event.isTrusted) return;
    if (event.button != null && event.button !== 0) return;
    const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
    const link = path.find((node) => node && node.nodeType === 1 &&
      node.matches('a[href],area[href]')) ||
      (event.target && event.target.closest ? event.target.closest('a[href],area[href]') : null);
    if (!link || !/^tel:\s*\S/i.test((link.getAttribute('href') || '').trim())) return;

    // Fail closed if Shopify's consent API or the existing Google tag is unavailable.
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' ||
        privacy.analyticsProcessingAllowed() !== true) return;
    if (typeof window.gtag !== 'function') return;

    // No telephone number, label, position or custom page parameter.
    // Never configure a second tag or interfere with the normal dialler action.
    window.gtag('event', 'phone_click', { send_to: 'G-6YGS8588K2' });
  }, { capture: true, passive: true });
})();
